import { Grid, Stack } from "@mui/material";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import TopSection from "../../../Components/Common/Top/TopSection";
import FGHistoryTracker from "./FGHistoryTracker";
import { setActiveDataElement } from "../../../redux/userSlice";


const FGHistory = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setActiveDataElement("FG Inventory"));
  }, [dispatch]);

  return (
    <>
      <Stack>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TopSection
              title="FG Inventory Upload History"
            />
            <div class="container">
              {/* top table */}
              <FGHistoryTracker />
             
            </div>
          </Grid>
        </Grid>
      </Stack>
    </>
  );
};

export default FGHistory;
